/*jshint esversion: 6 */

$(document).ready(function() {

    let hashObj = generateObjectFromHash(window.location.hash);

    // if ($('.smartCountInput').length > 0) {
    //     $('.smartCountInput').each(function() {
    //         smartCountValues($(this).data('id'), $('html').prop('lang'), $(this));
    //     });
    // }

    // Range Slider initialisieren
    $.each($("#td .rangeSlider input"), initRangeSlider);

    // if ($('.buchenFilter').length > 0) {
    //     $('.buchenFilter .date input.dpAnreise').datepicker({
    //         startDate: '+0d'
    //     }).on('changeDate', function(e) {
    //         let startDatum = e.date;
    //         let changedDatum = e.date;
    //
    //         // Abreisedatum holen
    //         let abreiseDatum = handleDate($('.buchenFilter .date input.dpAbreise').val(), 0);
    //
    //         // nur wenn das gewählte Anreisedatum größer als das hinterlegte Abreisedatum ist, soll das Abreisedatum um + 2 Tag erhöht werden
    //         if (startDatum >= abreiseDatum) {
    //             // + 2 Tage und das Abreisedatum korrigieren
    //             changedDatum.setDate(changedDatum.getDate() + 1);
    //             // StartDate darf nicht vor dem Anreise Datum liegen
    //             $('.buchenFilter .date input.dpAbreise').datepicker('setDate', changedDatum).datepicker('fill');
    //         }
    //         startDatum.setDate(startDatum.getDate());
    //         $('.buchenFilter .date input.dpAbreise').datepicker('setStartDate', startDatum);
    //     });
    //
    //     let abreiseDatum = handleDate($('.buchenFilter .date input.dpAbreise').val(), -1);
    //     $('.buchenFilter .date input.dpAbreise').datepicker({
    //         startDate: abreiseDatum
    //     });
    // }

    // Buchen An und Abreise gibt es auf der Vermieter META + Vermieter Detailseite
    // if ($('#td .buchenFilter').length > 0 || $('.ttgBigHeaderBoxUnterkunftOnTourdataDetail .buchenFilter').length > 0) {
    //     hashObj = setAndGetBuchenFilter(hashObj);
    // }

    // Init Functions
    if ($('#td').length) {

        if ($('#td #resultSet').data('sort')) {
            hashObj.sort = $('#td #resultSet').data('sort');
        } else {
            hashObj.sort = "title+asc";
        }

        if (hashObj.sort === 'distance+asc' && (!hashObj.latitude || !hashObj.longitude) && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                function(position) {

                    hashObj.latitude = position.coords.latitude;
                    hashObj.longitude = position.coords.longitude;
                    getMetaResult($('#td'), hashObj, false, true);

                },
                function(error) {

                    // Wenn GeoLocation nicht vorhanden lade Liste mit Standardsortierung title+asc & update Hash
                    geoLocationErrorOutput(error);
                    hashObj.sort = "title+asc";
                    $('#listOptions #sorting option[value="' + hashObj.sort + '"]').prop('selected', true);
                    getMetaResult($('#td'), hashObj, true, true);

                }
            );
        } else {
            getMetaResult($('#td'), hashObj, false, true);
        }

        if ($('.MobileModeOn:visible').length) {
            $('#td').addClass('mobileMode');
            $.each($('.reOrder'), function(k, v) {
                const reOrderHolderId = $(this).data('reorderpos');
                $('#' + reOrderHolderId).append($(this));
            });
        } else {
            $('#td').removeClass('mobileMode');
        }

    }

    window.onpopstate = function(event) {
        console.log('popstate');
        getMetaResult($('#td'), event.state, false, true);
    };

    $('#filterFacetten')
        .on('click', '.form-check', checkFacet)
        .on('keyup', '.qText', generateHashAndGetResult)
        .on('change', 'select.form-control', generateHashAndGetResult);
    // .on('click', '.buchenFilter .btn', generateHashAndGetResult);

    // $('.buchenFilter')
    //     .on('click', '.date a', function(e) {
    //         e.preventDefault();
    //         $(this).closest('.date').find('input').trigger('focus');
    //     })
    //     .on('click', '.personen a', smartCount)
    //     .on('change', '.kindAlter', function() {
    //         kinderAlterHackValidate($(this).closest('.buchenFilter'));
    //     });

    // $('#listOptions #sorting').change(generateHashAndGetResult);

    // $('#listOptions a').click(function(e) {
    //     e.preventDefault();
    //     if ($(this).hasClass('ttgTabKarte')) {
    //         //openMapsModal();
    //     } else {
    //         $('#listOptions .active').removeClass('active');
    //         $(this).closest('.option').addClass('active');
    //         generateHashAndGetResult(e);
    //     }
    // });

    // $('#td').on('click', '.dynamicAufAnfrageLink', function(e) {
    //     e.preventDefault();
    //     $('#listOptions .active').removeClass('active');
    //     $('#listOptions .aufAnfrageTab').addClass('active');
    //     generateHashAndGetResult(e);
    // });

    $('#td.mobileMode').on('click', '.header', function(e) {
        $(this).closest('#filterFacetten').toggleClass('open');
    });

});

// const handleDate = function(dateTmp, interval) {
//     let dateObj = dateTmp.split(".");
//     dateObj = new Date(dateObj[2], (dateObj[1] - 1), dateObj[0], '00', '00', '00');
//     // um interval raufzählen, zb. 1 Tag
//     dateObj.setDate(dateObj.getDate() + interval);
//     return dateObj;
// };

// const getURLParameter = function(name) {
//     const value = decodeURIComponent((RegExp(name + '=' + '(.+?)(&|$)').exec(location.search) || [true, ""])[1]);
//     return (value !== 'null') ? value : false;
// };

const getHashParameter = function(name) {
    const value = decodeURIComponent((RegExp(name + '=' + '(.+?)(&|$)').exec(location.hash) || [true, ""])[1]);
    return (value !== 'null') ? value : false;
};

const generateObjectFromHash = function(givenHash) {
    let hashObj = {};
    if (givenHash) {
        const hash = givenHash.replace('#', '');
        const hashArr = hash.split("&");
        $.each(hashArr, function(k, v) {
            const paramArr = v.split("=");
            hashObj[paramArr[0]] = decodeURI(paramArr[1]);
        });
    }
    return hashObj;
};

const generateHashFromObject = function(givenObj) {
    let newHash = "";
    let i = 0;
    $.each(givenObj, function(k, v) {
        newHash += (i > 0) ? "&" : "#";
        newHash += k + "=" + v;
        i++;
    });
    return (newHash === "") ? "#" : newHash;
};

const generateNewHashObject = function(updateObj) {
    const oldHashString = window.location.hash;
    const oldHashObj = generateObjectFromHash(oldHashString);
    let newHashObj = oldHashObj;
    $.each(updateObj, function(k, v) {

        if (k === 'offset' && parseInt(v) === 0) {
            delete newHashObj.offset; // entferne Parameter "offset" wenn 0
        } else {
            newHashObj[k] = v;
        }

    });
    return newHashObj;
};

const getMetaResult = function($td, params, updateState, loadFacets) {

    // wenn $_GET['no_cache']=1 gesetzt ist, soll es metaResult Action übergeben werden, damit das Plugin-Caching deaktiviert werden kann
    const urlQueryString = window.location.search;
    const urlParams = new URLSearchParams(urlQueryString);
    let noCache = 0;
    if (urlParams.get('no_cache')) {
        noCache = 1;
    }

    const response = (parseInt($td.find('#resultSet').data('type')) === 1765) ? 'meta-hypersearch' : 'meta';

    let lang = $td.data('lang');
    let sysLanguageUid = $td.data('syslanguageuid');
    if (lang == "cz") {
        lang = "cs";
    }

    let rootPage = $('body').data('rootpage');

    $.ajax({
        method: 'POST',
        url: "/index.php?id=" + rootPage + "&L=" + sysLanguageUid + "&response=" + response + "-resultset&tdType=" + $td.data('type') + "&type=" + $td.find('#resultSet').data('type'),
        // GET params only for identification in devTools
        data: {
            type: $td.find('#resultSet').data('type'),
            // t3 typeNum
            response: response,
            tdType: $td.data('type'),
            pageId: $td.data('pageid'),
            pluginUid: $td.data('pluginuid'),
            params: params,
            lang: lang,
            sysLanguageUid: sysLanguageUid,
            noCache: noCache,
            cachetime: $td.data('cachetime')
        },
        beforeSend: function(xhr, o) {

            // console.log('BEFORE');
            // console.log(o);
            // console.log(xhr);
            if ($('#td #filterFacetten .invalid').length) {
                $('#td #filterFacetten').addClass('invalidIndicator');
                document.getElementById("filterFacetten").scrollIntoView();
                return false;
            }
            if (!loadFacets) {
                document.getElementById("td").scrollIntoView();
            }
            $td.find('#resultSet').addClass('pause');
            spinner($td.find('#resultSet'), 'lds-roller');
            if (loadFacets && $td.find('#filterFacettenGruppen.loadIt').length) {
                $td.find('#filterFacettenGruppen').addClass('pause');
                spinner($td.find('#filterFacettenGruppen'), 'lds-roller');
            }

        },
        success: function(response, status, xhr) {

            // console.log('SUCCESS');
            // console.log(response);
            // console.log(status);
            // console.log(xhr);
            if (updateState) {
                let newHashString = generateHashFromObject(params);
                // console.log(newHashString);
                // console.log(params);
                if (newHashString !== "#") { // pushState nur setzten, wenn irgendwelche Hashparams vorhanden sind!
                    history.pushState(params, '', newHashString);
                }
            }
            $td.find('#resultSet').html(response);

            $('#resultSet .js-tooltip').each(function() {
                // Call the function with this as the current tooltip
                accessibleSimpleTooltipAria.apply(this);
            });

            // eventuell optimieren und über GET Param steuern
            // $.each($('#td.mobileMode .trustYou'), function(k,v){
            //     let iframeSrc = $(this).find('iframe').prop('src');
            //     iframeSrc = iframeSrc.replace('size=s', 'size=xs');
            //     $(this).find('iframe').prop('src', iframeSrc);
            // });
        },
        error: function(xhr, status, error) {

            // console.log('ERROR');
            // console.log(xhr);
            // console.log(status);
            // console.log(error);
        },
        complete: function(xhr, status) {

            // console.log('COMPLETE');
            // console.log(xhr);
            // console.log(status);
            // $td.find('#resultSet').fadeIn();
            $('[data-toggle="tooltip"]').tooltip();
            pagingMagic($td.find('.pagination'));
            $td.find('#resultSet').removeClass('pause');
            if (loadFacets && $td.find('#filterFacettenGruppen.loadIt').length) {
                getFacettenGruppen($td);
            }

        }
    });

};

let searchTimeout = null;
const getMetaResultMaybeWithDelay = function(delay, hashObj) {

    if (delay > 0) {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function() {
            getMetaResult($('#td'), hashObj, true, true);
        }, delay);
    } else {
        getMetaResult($('#td'), hashObj, true, true);
    }

};

const pagingMagic = function($pagination) {
    $.each($pagination, function(e) {
        const $nav = $(this).closest('nav');
        $(this).pagination({
            edges: 1,
            items: $nav.data('items'),
            itemsOnPage: $nav.data('limit'),
            currentPage: parseInt($nav.data('active')) + 1,
            displayedPages: $nav.data('visiblepages'),
            cssStyle: '',
            prevText: '&laquo;',
            nextText: '&raquo;',
            selectOnClick: false,
            onInit: function() {
                $nav.find('li').addClass('page-item').find('a, span').addClass('page-link');
            },
            onPageClick: function(pageNumber, event) {
                if (event) { // wird nur bei Klick auf Seite ausgelöst - bei Eingabe über das Input (Punkterl) nicht
                    event.preventDefault();
                }
                const updateObj = {
                    'offset': (pageNumber - 1) * parseInt($nav.data('limit')),
                    'sort': ($('#td #resultSet').data('sort')) ? $('#td #resultSet').data('sort') : "title+asc"
                };
                console.log(updateObj);
                const newHashObj = generateNewHashObject(updateObj);
                getMetaResult($('#td'), newHashObj, true, false);
            }
        });
    });
};

const getFacettenGruppen = function($td) {

    const response = (parseInt($td.find('#resultSet').data('type')) === 1765) ? 'meta-hypersearch' : 'meta';

    let rootPage = $('body').data('rootpage');

    let lang = $td.data('lang');
    let sysLanguageUid = $td.data('syslanguageuid');
    if (lang == "cz") {
        lang = "cs";
    }

    $.ajax({
        method: 'POST',
        url: "/index.php?id=" + rootPage + "&L=" + sysLanguageUid + "&response=" + response + "-facets&tdType=" + $td.data('type') + "&type=" + $td.find('#filterFacettenGruppen').data('type'),
        // GET params only for identification in devTools
        data: {
            type: $td.find('#filterFacettenGruppen').data('type'),
            // t3 typeNum
            response: 'facets',
            tdType: $td.data('type'),
            pageId: $td.data('pageid'),
            pluginUid: $td.data('pluginuid'),
            region: ($td.find('#regionsFilter').length) ? $td.find('#regionsFilter').val() : getRegionFromQparam(),
            // buchenFilter: (parseInt($td.find('#resultSet').data('type'))===1765) ? true : false,
            facettenGruppen: facettenGruppen,
            lang: lang,
            sysLanguageUid: sysLanguageUid,
            cachetime: $td.data('cachetime')
        },
        beforeSend: function(xhr, o) {

            // console.log('BEFORE');
            // console.log(o);
            // console.log(xhr);
            if (!$td.find('#filterFacettenGruppen.pause').length) {
                $td.find('#filterFacettenGruppen').addClass('pause');
                spinner($td.find('#filterFacettenGruppen'), 'lds-roller');
            }

        },
        success: function(response, status, xhr) {

            // console.log('SUCCESS');
            // console.log(response);
            // console.log(status);
            // console.log(xhr);

            // SETZE Werte basierend auf Hashtag
            const qParam = getHashParameter('q');
            $td.find('#filterFacettenGruppen').html(response);

            // response manipulieren > wenn gespeicherter Filter vorhanden/ersetzen
            const $savedFilter = $('#savedFilter .filter');
            if ($savedFilter.length) {
                const savedFilterID = $savedFilter.find('.collapse').prop('id');
                const $gruppeBasedOnResult = $td.find('#sortableFilter .gruppe #' + savedFilterID).closest('.gruppe');
                $savedFilter.insertBefore($gruppeBasedOnResult).show();
                $gruppeBasedOnResult.remove();
            }

            // Öffne immer die ersten 3 Facettengruppen
            let i = 0;
            $.each($td.find('#sortableFilter .gruppe'), function(k, v) {
                if (i < 3) {
                    $(this).find('.btn.collapsed').removeClass('collapsed').next('.collapse').addClass('show');
                }
                i++;
            });

            // Checkboxen
            $.each($td.find('.form-check-input'), function(k, v) {
                const keyword = $(this).closest('.gruppe').data('qkeyword');
                let val = '"' + $(this).data('qvalue') + '"'; // mit Quotes für exact Match
                if (keyword && (keyword.indexOf('number_') >= 0 || keyword.indexOf('rating_') >= 0)) {
                    val = $(this).data('qvalue'); // RANGE
                }
                const isQparamValueActive = qParam.indexOf(val);
                const isQparamKeywordActive = qParam.indexOf(keyword);

                if (isQparamValueActive >= 0 && isQparamKeywordActive >= 0) {

                    // Aktiviere Checkbox wenn Wert vorhanden
                    checkFacet(false, $(this).closest('div.form-check'));

                    // Öffne Facettengruppe wenn Facette darin gewählt ist
                    $(this).closest('.gruppe').find('.btn.collapsed').removeClass('collapsed').next('.collapse').addClass('show');

                }
            });

            // Suchfeld
            if (qParam.indexOf('text:"') >= 0) {
                let qText = qParam.substr(qParam.indexOf('text:"')); // qParam ab text:"
                qText = qText.replace('text:"', ""); // entferne text:"
                const replaceAfter = qText.substr(qText.indexOf('"')); // zu entfernender String nach qText (folgt nach dem nun ersten Anführungzeichen)
                qText = qText.replace(replaceAfter, ""); // entferne nachfolgenden String, sodass nur qText=Suchstring über bleibt
                $td.find('.qText').val(qText).data('lastSearchVal', qText); // fülle Input mit Suchwort
            }

            // selects (ort/region)
            $.each($td.find('select.form-control'), function(k, v) {
                const qKeyword = $(this).data('qkeyword');
                if (qParam.indexOf(qKeyword) >= 0) {
                    let string = qParam.substr(qParam.indexOf(qKeyword)).replace(qKeyword + ':"', "");
                    const value = string.substr(0, string.indexOf('"'));
                    $(this).val(value);
                }
            });

            // Tourenfilter (RangeSlider)
            $.each($td.find('#filterFacettenGruppen .rangeSlider input'), function(k, v) {

                initRangeSlider($(v));

                const qkeyword = $(v).data('qkeyword');
                if (qParam.indexOf(qkeyword + ':') >= 0) {

                    const maxVal = $(v).slider('getAttribute').max;
                    let thisQSub = qParam.substr(qParam.indexOf(qkeyword + ':'));
                    thisQSub = thisQSub.substr(0, thisQSub.indexOf(']'));
                    let thisQVal = thisQSub.replace(qkeyword + ':[', '');
                    thisQVal = thisQVal.replace(']', '');
                    thisQValArr = thisQVal.split(' TO ');

                    let valToInt = parseInt(thisQValArr[1]);
                    let valToString = valToInt / parseInt($(v).data('umrechnung'));
                    if (parseInt(thisQValArr[1]) >= maxVal || thisQValArr[1] == '*') {
                        valToInt = maxVal;
                        valToString = maxVal / parseInt($(v).data('umrechnung')) + "+";
                    }

                    $(v).slider('setValue', [parseInt(thisQValArr[0]), valToInt]);
                    $(v).closest('.rangeSlider').find('.von').text(parseInt(thisQValArr[0]) / parseInt($(v).data('umrechnung')));
                    $(v).closest('.rangeSlider').find('.bis').text(valToString + " " + $(v).data('suffix'));

                }

            });

        },
        error: function(xhr, status, error) {

            // console.log('ERROR');
            // console.log(xhr);
            // console.log(status);
            // console.log(error);
        },
        complete: function(xhr, status) {

            // console.log('COMPLETE');
            // console.log(xhr);
            // console.log(status);
            $td.find('#filterFacettenGruppen').removeClass('pause');

        }
    });

};

const spinner = function($elTo, spinnerClass) {

    const $spinnerTemplate = $('.' + spinnerClass + '.template');
    const $spinner = $spinnerTemplate.clone().removeClass('template');
    $elTo.append($spinner);

};

const checkFacet = function(e, el) {

    $check = (el) ? $(el) : $(this);

    if (e) { // CLICK (e=Event vorhanden)
        e.preventDefault();
        if ($check.find('.form-check-input').prop('checked') === true) {
            $check.find('.form-check-input').prop('checked', false).closest('.form-check').removeClass('checked').find('span.far').removeClass('fa-check-square').addClass('fa-square');
        } else {
            $check.find('.form-check-input').prop('checked', true).closest('.form-check').addClass('checked').find('span.far').removeClass('fa-square').addClass('fa-check-square');
        }
        generateHashAndGetResult();
        // Filtergruppe wird gecloned und gespeichert (sofern zumindest ein Wert der Gruppe gecheckt ist)
        // > um dieses Element nach laden der "neuen" FilterFacetten (unverändert) wieder einzufügen
        // > (bzw. den entsprechenden Teil zu ersetzen)
        // > Filtergruppe in der etwas geklickt wurde soll nicht verändert werden (=bestehen bleiben)
        // > Ausnahme: wenn letzter Wert der Gruppe entfernt wurde (dann lade auch diese Gruppe basierend am MetaResult neu)
        // > Logik des ersetzens wird getFacettenGruppen()/SUCCESS behandelt
        if ($check.closest('.filter.gruppe').find('.form-check-input:checked').length) {
            let $savedFilter = $('#savedFilter');
            $savedFilter.empty().append($check.closest('.filter.gruppe').clone().hide());
        }

    } else { // INITIAL (nach Laden der Facettengruppen)

        // Facette checken/unchecken
        if ($check.find('.form-check-input').prop('checked') === false) {
            $check.find('.form-check-input').prop('checked', true).closest('.form-check').addClass('checked').find('span.far').removeClass('fa-square').addClass('fa-check-square');
        }

    }

};

const generateHashAndGetResult = function(e) {

    if ($(this).hasClass('btn')) {
        e.preventDefault();
    }

    if ($(this).prop('id') === "regionsFilter") {
        $('#ortsFilter').val(""); // Reset OrtsSelect wenn neue Region gewählt wird
    }

    let newHashObj = {
        q: qStringGenerator()
    };

    if (newHashObj.q.length <= 0) {
        delete newHashObj.q;
    }

    // if ($('.buchenFilter').length) {
    //     newHashObj = getBuchenFilterValues(newHashObj);
    // }

    const delay = ($(this).data('delay')) ? parseInt($(this).data('delay')) : 0;

    // if ($('#listOptions #sorting').length || $('#td #resultSet').data('sort')) {
    //     newHashObj.sort = ($('#listOptions #sorting').length) ? $('#listOptions #sorting').val() : $('#td #resultSet').data('sort');
    if ($('#td #resultSet').data('sort')) {
        newHashObj.sort = $('#td #resultSet').data('sort');

        if (newHashObj.sort === 'distance+asc' && (!newHashObj.latitude || !newHashObj.longitude) && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                function(position) {

                    newHashObj.latitude = position.coords.latitude;
                    newHashObj.longitude = position.coords.longitude;
                    getMetaResultMaybeWithDelay(delay, newHashObj);

                },
                function(error) {

                    geoLocationErrorOutput(error);
                    newHashObj.sort = "title+asc";
                    $('#listOptions #sorting option[value="' + newHashObj.sort + '"]').prop('selected', true);
                    getMetaResultMaybeWithDelay(delay, newHashObj);

                }
            );
        } else {
            getMetaResultMaybeWithDelay(delay, newHashObj);
        }

    } else {
        newHashObj.sort = 'title+asc';
        getMetaResultMaybeWithDelay(delay, newHashObj);
    }

};

const qStringGenerator = function() {

    let qString = '';

    // Textstring
    qString += ($('#searchString').length && $('#searchString').val().length) ? 'text:"' + $('#searchString').val() + '"' : '';

    // Ort & Region
    $.each($('#td #filterFacetten select.form-control'), function(k, v) {
        if ($(this).val().length > 0) {
            const qKeyword = $(this).data('qkeyword');
            const qValue = '"' + $(this).val() + '"';
            qString += (qString.length > 0) ? " AND " + qKeyword + ":" + qValue : qKeyword + ":" + qValue;
        }
    });

    // Facetten
    $.each($('#td #filterFacetten .facetten.gruppe .form-check-input:checked'), function(k, v) {
        qString += (qString.length > 0) ? " AND " + $(this).val() : $(this).val();
    });

    // Filter
    $.each($('#td #filterFacetten .filter.gruppe'), function(k, v) {

        const $inputs = $(this).find('.form-check-input:checked');
        if ($inputs.length) {

            const qKeyword = $(this).data('qkeyword');
            qString += (qString.length > 0) ? " AND " + qKeyword + ":(" : qKeyword + ":(";
            let i = 0;
            $.each($inputs, function(k, v) {
                const qValue = '"' + $(this).data('qvalue') + '"';
                qString += (i > 0) ? " OR " + qValue : qValue;
                i++;
            });
            qString += ")";

        }
    });

    $.each($('#td #tourenFilter .rangeSlider input'), function(k, v) {

        const qKeyword = $(this).data('qkeyword');
        const maxVal = parseInt($(this).data('slider-max'));
        const toVal = (maxVal <= $(this).slider('getValue')[1]) ? '*' : $(this).slider('getValue')[1];
        const qValue = "[" + $(this).slider('getValue')[0] + " TO " + toVal + "]";
        qString += (qString.length > 0) ? " AND " + qKeyword + ":" + qValue : qKeyword + ":" + qValue;

    });

    return qString;

};

// const smartCount = function(e) {
//
//     e.preventDefault();
//
//     // count down
//     if ($(this).hasClass('btn-minus')) {
//         e.preventDefault();
//         const $input = $(this).closest('.input-group').find('input');
//         const value = $input.val();
//         const valuesArr = smartCountValues($input.data('id'), $('html').prop('lang'));
//         $.each(valuesArr, function(i, v) {
//             if (value === v.label) {
//                 let index = i - 1;
//                 if (index >= 0) {
//                     $input.val(valuesArr[index].label);
//                     kinderAlterHack($input.data('id'), valuesArr[index].value);
//                 }
//             }
//         });
//     }
//
//     // count up
//     if ($(this).hasClass('btn-plus')) {
//         e.preventDefault();
//         const $input = $(this).closest('.input-group').find('input');
//         const value = $input.val();
//         const valuesArr = smartCountValues($input.data('id'), $('html').prop('lang'));
//         $.each(valuesArr, function(i, v) {
//             if (value === v.label) {
//                 let index = i + 1;
//                 if (index < valuesArr.length) {
//                     $input.val(valuesArr[index].label);
//                     kinderAlterHack($input.data('id'), valuesArr[index].value);
//                 }
//             }
//         });
//     }
//
// };

// const smartCountValues = function(id, lang, $init, entry) {
//
//     const smartValues = {
//         'de': {
//             'erwachsene': [
//                 {
//                     "value": 1,
//                     "label": "1 Erwachsene(r)"
//                 },
//                 {
//                     "value": 2,
//                     "label": "2 Erwachsene"
//                 },
//                 {
//                     "value": 3,
//                     "label": "3 Erwachsene"
//                 },
//                 {
//                     "value": 4,
//                     "label": "4 Erwachsene"
//                 },
//                 {
//                     "value": 5,
//                     "label": "5 Erwachsene"
//                 },
//                 {
//                     "value": 6,
//                     "label": "6 Erwachsene"
//                 },
//                 {
//                     "value": 7,
//                     "label": "7 Erwachsene"
//                 },
//                 {
//                     "value": 8,
//                     "label": "8 Erwachsene"
//                 },
//                 {
//                     "value": 9,
//                     "label": "9 Erwachsene"
//                 },
//                 {
//                     "value": 10,
//                     "label": "10 Erwachsene"
//                 }
//             ],
//             'kinder': [
//                 {
//                     "value": 0,
//                     "label": "0 Kinder"
//                 },
//                 {
//                     "value": 1,
//                     "label": "1 Kind"
//                 },
//                 {
//                     "value": 2,
//                     "label": "2 Kinder"
//                 },
//                 {
//                     "value": 3,
//                     "label": "3 Kinder"
//                 },
//                 {
//                     "value": 4,
//                     "label": "4 Kinder"
//                 }
//             ]
//         },
//         'en': {
//             'erwachsene': [
//                 {
//                     "value": 1,
//                     "label": "1 adult"
//                 },
//                 {
//                     "value": 2,
//                     "label": "2 adults"
//                 },
//                 {
//                     "value": 3,
//                     "label": "3 adults"
//                 },
//                 {
//                     "value": 4,
//                     "label": "4 adults"
//                 },
//                 {
//                     "value": 5,
//                     "label": "5 adults"
//                 },
//                 {
//                     "value": 6,
//                     "label": "6 adults"
//                 },
//                 {
//                     "value": 7,
//                     "label": "7 adults"
//                 },
//                 {
//                     "value": 8,
//                     "label": "8 adults"
//                 },
//                 {
//                     "value": 9,
//                     "label": "9 adults"
//                 },
//                 {
//                     "value": 10,
//                     "label": "10 adults"
//                 }
//             ],
//             'kinder': [
//                 {
//                     "value": 0,
//                     "label": "0 children"
//                 },
//                 {
//                     "value": 1,
//                     "label": "1 child"
//                 },
//                 {
//                     "value": 2,
//                     "label": "2 children"
//                 },
//                 {
//                     "value": 3,
//                     "label": "3 children"
//                 },
//                 {
//                     "value": 4,
//                     "label": "4 children"
//                 }
//             ]
//         },
//         'cz': {
//             'erwachsene': [
//                 {
//                     "value": 1,
//                     "label": "1 dospělý"
//                 },
//                 {
//                     "value": 2,
//                     "label": "2 dospělí"
//                 },
//                 {
//                     "value": 3,
//                     "label": "3 dospělí"
//                 },
//                 {
//                     "value": 4,
//                     "label": "4 dospělí"
//                 },
//                 {
//                     "value": 5,
//                     "label": "5 dospělí"
//                 },
//                 {
//                     "value": 6,
//                     "label": "6 dospělí"
//                 },
//                 {
//                     "value": 7,
//                     "label": "7 dospělí"
//                 },
//                 {
//                     "value": 8,
//                     "label": "8 dospělí"
//                 },
//                 {
//                     "value": 9,
//                     "label": "9 dospělí"
//                 },
//                 {
//                     "value": 10,
//                     "label": "10 dospělí"
//                 }
//             ],
//             'kinder': [
//                 {
//                     "value": 0,
//                     "label": "0 dětí"
//                 },
//                 {
//                     "value": 1,
//                     "label": "1 dítě"
//                 },
//                 {
//                     "value": 2,
//                     "label": "2 děti"
//                 },
//                 {
//                     "value": 3,
//                     "label": "3 děti"
//                 },
//                 {
//                     "value": 4,
//                     "label": "4 děti"
//                 }
//             ]
//         },
//         'it': {
//             'erwachsene': [
//                 {
//                     "value": 1,
//                     "label": "1 adulto"
//                 },
//                 {
//                     "value": 2,
//                     "label": "2 adulti"
//                 },
//                 {
//                     "value": 3,
//                     "label": "3 adulti"
//                 },
//                 {
//                     "value": 4,
//                     "label": "4 adulti"
//                 },
//                 {
//                     "value": 5,
//                     "label": "5 adulti"
//                 },
//                 {
//                     "value": 6,
//                     "label": "6 adulti"
//                 },
//                 {
//                     "value": 7,
//                     "label": "7 adulti"
//                 },
//                 {
//                     "value": 8,
//                     "label": "8 adulti"
//                 },
//                 {
//                     "value": 9,
//                     "label": "9 adulti"
//                 },
//                 {
//                     "value": 10,
//                     "label": "10 adulti"
//                 }
//             ],
//             'kinder': [
//                 {
//                     "value": 0,
//                     "label": "0 bambini"
//                 },
//                 {
//                     "value": 1,
//                     "label": "1 bambino"
//                 },
//                 {
//                     "value": 2,
//                     "label": "2 bambini"
//                 },
//                 {
//                     "value": 3,
//                     "label": "3 bambini"
//                 },
//                 {
//                     "value": 4,
//                     "label": "4 bambini"
//                 }
//             ]
//         }
//     };
//
//     if ($init) {
//         if (id === 'erwachsene') {
//             if (entry) {
//                 $init.val(smartValues[lang][id][entry - 1].label);
//             } else {
//                 $init.val(smartValues[lang][id][1].label);
//             }
//         } else {
//             if (entry) {
//                 $init.val(smartValues[lang][id][entry].label);
//             } else {
//                 $init.val(smartValues[lang][id][0].label);
//             }
//         }
//     } else {
//         return smartValues[lang][id];
//     }
//
// };

// const kinderAlterHack = function(id, value) {
//
//     if (id === 'kinder') {
//         switch (value) {
//         case 0:
//             // $('').removeClass('d-none');
//             $('.kinderAlterWrapper, .kind1_alter, .kind2_alter, .kind3_alter, .kind4_alter').addClass('d-none').val('');
//             break;
//         case 1:
//             $('.kinderAlterWrapper, .kind1_alter').removeClass('d-none');
//             $('.kind2_alter, .kind3_alter, .kind4_alter').addClass('d-none').val('');
//             break;
//         case 2:
//             $('.kinderAlterWrapper, .kind1_alter, .kind2_alter').removeClass('d-none');
//             $('.kind3_alter, .kind4_alter').addClass('d-none').val('');
//             break;
//         case 3:
//             $('.kinderAlterWrapper, .kind1_alter, .kind2_alter, .kind3_alter').removeClass('d-none');
//             $('.kind4_alter').addClass('d-none').val('');
//             break;
//         case 4:
//             $('.kinderAlterWrapper, .kind1_alter, .kind2_alter, .kind3_alter, .kind4_alter').removeClass('d-none');
//             // $('').addClass('d-none').value('');
//             break;
//         }
//         kinderAlterHackValidate($('.kinderAlterWrapper').closest('.buchenFilter'));
//     }
//
// };

// const kinderAlterHackValidate = function($buchenFilter) {
//
//     let notValidCount = 0;
//     $.each($buchenFilter.find('.kindAlter:not(.d-none)'), function() {
//         if(!$(this).val()) {
//             $(this).addClass('invalid');
//             notValidCount++;
//         } else {
//             $(this).removeClass('invalid');
//         }
//     });
//     if (notValidCount>0) {
//         $buchenFilter.find('.btn').addClass('disabled').prop('disabled', true);
//     } else {
//         $buchenFilter
//             .find('.btn').removeClass('disabled').prop('disabled', false)
//             .closest('#filterFacetten').removeClass('invalidIndicator');
//     }
//
// };

// const getBuchenFilterValues = function(hashObj) {
//
//     // Buchen An und Abreise gibt es auf der Vermieter META + Vermieter Detailseite
//     if ($('#td .buchenFilter').length > 0 || $('.ttgBigHeaderBoxUnterkunftOnTourdataDetail .buchenFilter').length > 0) {
//         hashObj.startdate = $('.dpAnreise').val();
//         hashObj.enddate = $('.dpAbreise').val();
//         hashObj.occupation = parseInt($('.erwachsene').val());
//         if (parseInt($('.kinder').val()) > 0) {
//             hashObj.occupation += ":";
//             let i = 0;
//             $.each($('.kindAlter:not(.d-none)'), function(e) {
//                 hashObj.occupation += (i > 0) ? ',' + $(this).val() : $(this).val();
//                 i++;
//             });
//         }
//         const $sliderInput = $('#td .rangeSlider input');
//         if ($sliderInput.length > 0) {
//             hashObj.pricefrom = $sliderInput.slider('getValue')[0];
//             hashObj.priceto = ($sliderInput.slider('getValue')[1] >= $sliderInput.slider('getAttribute').max) ? 9999 : $sliderInput.slider('getValue')[1]; // check ob PriceTo größer||gleich max Wert > wenn ja setze PriceTo auf 10.000 (open range)
//             hashObj.filterstate = $('#td #listOptions .option.active a').data('filterstate');
//         }
//     }
//     return hashObj;
//
// };

// const setAndGetBuchenFilter = function(hashObj) {
//
//     if (!hashObj.startdate) {
//         hashObj.startdate = $('.dpAnreise').val();
//     } else {
//         $('.dpAnreise').val(hashObj.startdate);
//     }
//
//     if (!hashObj.enddate) {
//         hashObj.enddate = $('.dpAbreise').val();
//     } else {
//         $('.dpAbreise').val(hashObj.enddate);
//     }
//
//     if (!hashObj.occupation) {
//         hashObj.occupation = parseInt($('.erwachsene').val());
//     } else {
//         let occupationArr = hashObj.occupation.split('+');
//         $.each(occupationArr, function(k, einheit) {
//
//             let einheitArr = einheit.split(':');
//             smartCountValues('erwachsene', $('html').prop('lang'), $('.erwachsene'), parseInt(einheitArr[0]));
//
//             if (einheitArr.length > 1) {
//                 $('.kinderAlterWrapper').removeClass('d-none');
//                 let kinderArr = einheitArr[1].split(',');
//                 $.each(kinderArr, function(k, kind) {
//
//                     smartCountValues('kinder', $('html').prop('lang'), $('.buchenFilter .kinder'), kinderArr.length);
//
//                     $.each(kinderArr, function(k, v) {
//                         let kind = k + 1;
//                         $('.kind' + kind + '_alter').removeClass('d-none').val(v);
//                     });
//
//                 });
//             }
//
//         });
//     }
//
//     const $sliderInput = $('#td .rangeSlider input');
//     if ($sliderInput.length > 0) {
//         if (!hashObj.pricefrom || !hashObj.priceto) {
//             hashObj.pricefrom = $sliderInput.data('sliderValue')[0];
//             // hashObj.priceto = $sliderInput.data('sliderValue')[1];
//             hashObj.priceto = 9999; // wenn kein Wert übergeben
//         } else {
//             const maxVal = $sliderInput.slider('getAttribute').max;
//             let valToInt = parseInt(hashObj.priceto);
//             let valToString = hashObj.priceto;
//             if (valToInt >= maxVal) {
//                 valToInt = 9999;
//                 valToString = maxVal + "+";
//             }
//             $sliderInput.slider('setValue', [parseInt(hashObj.pricefrom), valToInt]);
//             $('#td .rangeSlider .von').text(hashObj.pricefrom);
//             $('#td .rangeSlider .bis').text(valToString + " " + $sliderInput.data('suffix'));
//         }
//     }
//
//     if (!hashObj.filterstate) {
//         hashObj.filterstate = $('#td #listOptions .active a').data('filterstate');
//     } else {
//         $('#td #listOptions .option.active').removeClass('active');
//         $('#td #listOptions .option a[data-filterstate="' + hashObj.filterstate + '"]').closest('.option').addClass('active');
//     }
//
//     return hashObj;
//
// };

const getRegionFromQparam = function() {

    const q = getHashParameter('q');
    const posArea = q.indexOf('area:"');

    if (posArea === -1) {
        return '';
    }

    let area = q.substr(posArea + 6);
    const posAreaEnd = area.indexOf('"');
    // area = area.substr(0,posAreaEnd);
    return area.substr(0, posAreaEnd);

};

const initRangeSlider = function($el) {

    const $inputEl = ($el) ? $el : $(this);
    const umrechnungsKey = ($inputEl.data('umrechnung')) ? parseInt($inputEl.data('umrechnung')) : 1;
    const slider = $inputEl.slider({
        handle: 'square',
        tooltip: 'hide'
    }).on('slide', function(v) {
        const maxVal = slider.slider('getAttribute').max;
        const valFrom = v.value[0];
        let valTo = v.value[1];
        $inputEl.closest('.rangeSlider').find('.von').text(valFrom / umrechnungsKey);
        valTo = (valTo >= maxVal) ? maxVal / umrechnungsKey + "+" : valTo / umrechnungsKey;
        $inputEl.closest('.rangeSlider').find('.bis').text(valTo + " " + $inputEl.data('suffix'));
    }).on('slideStop', function(v) {
        if ($inputEl.closest('#tourenFilter').length) {
            generateHashAndGetResult();
        }
    });

    // Init Label Values
    const maxVal = slider.slider('getAttribute').max;
    let values = slider.data('value').split(',');
    $inputEl.closest('.rangeSlider').find('.von').text(values[0] / umrechnungsKey);
    values[1] = (values[1] >= maxVal) ? maxVal / umrechnungsKey + "+" : values[1] / umrechnungsKey;
    $inputEl.closest('.rangeSlider').find('.bis').text(values[1] + " " + $inputEl.data('suffix'));

};

const geoLocationErrorOutput = function(error) {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            console.log("User denied the request for Geolocation.");
            break;
        case error.POSITION_UNAVAILABLE:
            console.log("Location information is unavailable.");
            break;
        case error.TIMEOUT:
            console.log("The request to get user location timed out.");
            break;
        case error.UNKNOWN_ERROR:
            console.log("An unknown error occurred.");
            break;
    }
};
